import { Scene } from "phaser";
import { GButton } from "../gameobjects/GButton";
import { ExpandingCircle } from "../gameobjects/ExpandingCircle";

import { formatNumberWithCommas, padNumber, truncateString, updateRegistry } from "../utils";

// The HUD scene is the scene that shows the points and the remaining time.
export class HudScene extends Scene {
    
    remaining_time = 0;

    remaining_time_text;
    points_text;

    constructor() {
        super("HudScene");
        this.retryAttempts = 0;  // Track retry attempts
        this.maxRetries = 5;     // Optional: Limit retries
        this.retryDelay = 5000;  // Retry delay in milliseconds (5 seconds)
        
    }

    init(data) {
        //this.cameras.main.fadeIn(500, 0, 0, 0);
    }

    create() {

        this.registry.events.on('changedata', updateRegistry);

        // Listen for the 'update-text' event from Scene B
        this.game.events.on('update-balance', this.updateBalance, this);
         // Retrieve parameters from localStorage
         const storedParamsJSON = localStorage.getItem('gameParams');
         const storedParams = JSON.parse(storedParamsJSON) || {};
 
         const token = storedParams['token'] || '';
         const brand = storedParams['brand'] || '';

         this.registry.set('brand', brand);
         this.registry.set('token', token);


        const playerProfile = this.add.sprite(0, 0, 'pack', 'Header 1 - BG.png').setOrigin(0);
        
        const playerProfileImage = this.add.image(64, 64, 'player-profile-image').setOrigin(0.5).setDisplaySize(64,64);
        
        const HudButtonSizeX = 40;
        const UserNameStyle = { fontSize: 26, fontFamily: 'Oswald', color: '#fff', fontWeight:700 };
        const BalanceStyle = { fontSize: 24, fontFamily: 'Oswald', color: '#fff', fontWeight:500,  lineSpacing: 10};


        const UserName = this.registry.get('username');
        this.userNameText = this.add.text(64*2, 30, truncateString(UserName, 10),  UserNameStyle);
        this.userNameText.setFontStyle("700");

        this.balanceText = this.add.text(64*2, 66, `-`, BalanceStyle).setOrigin(0,0);

        this.balanceText.setLetterSpacing(2)


        const ButtonHistory = new GButton(this, this.scale.width - (HudButtonSizeX/2 + 16) *2, 60, {
            texturePack: "pack", 
            idleTexture: 'Header 1 - Button BG - Default.png',
            hoverTexture: 'Header 1 - Button BG - Default.png',
            clickedTexture: 'Header 1 - Button BG - Clicked.png',
            disabledTexture: 'Header 1 - Button BG - Default.png',
            // text: 'Click Me',
            icon: {
                image: 'history-icon.png',
                scale: 0.6
            },
            onClick: () => {
                //console.log('Button ButtonHistory!');
                // this.scene.stop("MenuScene")
                // this.scene.stop("TimerScene")
                // this.scene.stop("InfoScene")
                this.scene.launch("HistoryScene")
            }
        });
        
        //ButtonHistory.setScale(0.8)


        const ButtonInfo = new GButton(this, this.scale.width - (HudButtonSizeX*2 + 10) *2, 60, {
            texturePack: "pack", 
            idleTexture: 'Header 1 - Button BG - Default.png',
            hoverTexture: 'Header 1 - Button BG - Default.png',
            clickedTexture: 'Header 1 - Button BG - Clicked.png',
            disabledTexture: 'Header 1 - Button BG - Default.png',
            // text: 'Click Me',
            icon: {
                image: 'info-icon.png',
                scale: 0.6
            },
            onClick: () => {
                //console.log('Button InfoScene!');
                // this.scene.stop("MenuScene")
                // this.scene.stop("TimerScene")
                // this.scene.stop("HistoryScene")
                this.scene.launch("DetailsScene")
            }
        });
        
        //ButtonInfo.setScale(0.8)

        this.input.on('pointerdown', (pointer) => {
            // Create a new ExpandingCircle at the pointer's position
            new ExpandingCircle(this, pointer.x, pointer.y);
        });


         // Start fetching balance stream
         this.fetchBalanceStream();
         //console.log("this.fetchBalanceStream(token, brand);",token, brand )

    }

    update() {
        //this.fps.setText(this.game.renderer.getFps());
    }

    updateBalance(newbalance){

        //console.log("newbalance",newbalance)
        this.updateBalanceUI(newbalance)

    }

     // Async function to fetch and process the balance stream
     async fetchBalanceStream() {
        try {
            const base_url = `${import.meta.env.VITE_BACKEND_BASE_URL}:${import.meta.env.VITE_BACKEND_PORT}`;
           
            const response = await fetch(`${base_url}/api/v1/players/sync-balance`, {
                method: 'GET',
                headers: {
                    'X-GA-ClientId': this.registry.get('brand'), // Add the X-GA-ClientId header
                    'X-GA-Authentication-Token': this.registry.get('token'), // Add the X-GA-ClientSecret header
                    //'Content-Type': 'application/octet-stream', // Optional, depends on the server setup
                },
                 mode: 'cors'
            });

           

            // Get a reader from the response body
            const reader = response.body.getReader();

            const processChunk = async () => {
                //console.log("response", response)
                const { done, value } = await reader.read();
                if (done) {
                    console.log("Stream ended. Attempting to reconnect...");
                    this.retryConnection();
                    return;
                }

                // Convert ArrayBuffer to Float64 (for balance)
                const dataView = new DataView(value.buffer);
                const balance = dataView.getFloat64(0, true); // Assuming little-endian
                this.registry.set('my-balance', balance);
                // Update the balance on the game UI
                this.updateBalanceUI(balance);

                // Continue reading the next chunk
                processChunk();
            };

            
            // Reset retry attempts on successful connection
            this.retryAttempts = 0;

            // Start processing the stream
            processChunk();
        } catch (error) {
            console.error("Error receiving balance stream:", error);
            this.retryConnection();
        }
    }

    // Retry connection after a delay
    retryConnection() {
        if (this.retryAttempts < this.maxRetries) {
            this.retryAttempts++;
            console.log(`Retrying connection in ${this.retryDelay / 1000} seconds... (Attempt ${this.retryAttempts})`);

            setTimeout(() => {
                this.fetchBalanceStream();
            }, this.retryDelay);
        } else {
            console.error("Max retry attempts reached. Could not reconnect to the stream.");
        }
    }

    // Method to update the balance text in the game
    updateBalanceUI(balance) {
        this.balanceText.setText('$' + formatNumberWithCommas(balance));
        this.balanceText.setLetterSpacing(2)
    }

  
}